export const PROCESS_FILLED = {
    processNumber: '123456'
};